import {delegate} from 'tippy.js';

export default function initTooltips() {
  delegate('body', {
    target: '.js-tooltip',
    allowHTML: true,
    theme: 'light',
    interactive: true,
    // showOnCreate: true,
    // trigger: 'manual',
    content(reference) {
      const content = reference.querySelector('.js-tooltip-content');
      if (content) return content.innerHTML;
      return '';
    },
    onMount(instance) {
      const placement = instance.reference.dataset.tooltipPlacement || 'bottom';
      const offsetX = instance.reference.dataset.tooltipOffsetX || 0;
      const offsetY = instance.reference.dataset.tooltipOffsetY || 0;

      instance.setProps({
        placement,
        offset: `${offsetX}, ${offsetY}`,
      });
    },
  });
}

